var CompanySize;
(function (CompanySize) {
    CompanySize["SME"] = "SME";
    CompanySize["MID_MARKET"] = "Mid Market";
    CompanySize["CORPORATE"] = "Corporate";
})(CompanySize || (CompanySize = {}));
export default CompanySize;
